import React, { FC, useMemo } from 'react';

// components
import AampeTooltip from '../../../../../components/shared/AampeTooltip/AampeTooltip';
import styled from 'styled-components';

// constants
import aampeTheme from '../../../../../constants/aampeTheme';

import { numberOfBarsPerLabel } from '../../../../../models/label.model';

interface StyledProps {
    isCompleted?: boolean;
    color?: string;
    isFilled?: boolean;
}

interface GamificationProgressBarProps {
    count: number;
    color: string;
}

const GamificationProgressBar: FC<
    React.PropsWithChildren<GamificationProgressBarProps>
> = ({ count, color }) => {
    const isCompleted = count >= numberOfBarsPerLabel;

    const barRating = useMemo(() => {
        const stars = [];

        for (let i = 0; i < numberOfBarsPerLabel; i++) {
            const isFilled = i < count;

            stars.push(
                <AampeTooltip
                    key={i}
                    placement="top"
                    title={
                        !count &&
                        'Add a variant to your message and label it with this label to earn a star!'
                    }
                >
                    <StarBar isFilled={isFilled} color={color} />
                </AampeTooltip>,
            );
        }

        return stars;
    }, [count, color]);

    return (
        <StarContainer isCompleted={isCompleted}>
            <ProgressBarContainer>
                <ProgressBarText>
                    {count}/{numberOfBarsPerLabel}
                </ProgressBarText>
                <StarContainer>{barRating}</StarContainer>
            </ProgressBarContainer>
        </StarContainer>
    );
};

const ProgressBarContainer = styled.div({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
});

const ProgressBarText = styled.div({
    marginRight: aampeTheme.spacing(1),
    fontSize: '12px',
    color: aampeTheme.colors.gray600,
    fontWeight: 400,
});

const StarContainer = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'isCompleted',
})<{ isCompleted?: boolean }>(({ isCompleted }) => ({
    flex: isCompleted ? 3 : 2,
    display: 'flex',
}));

const StarBar = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'isFilled',
})<StyledProps>(({ isFilled }) => ({
    width: '20px',
    height: '4px',
    backgroundColor: isFilled
        ? aampeTheme.colors.orange400
        : aampeTheme.colors.bordersWG01,
    marginRight: aampeTheme.spacing(0.5),
    borderRadius: aampeTheme.borderRadius.large,
}));

export default GamificationProgressBar;
